import { render, staticRenderFns } from "./SubPantalla.vue?vue&type=template&id=0c4b4776&"
import script from "./SubPantalla.vue?vue&type=script&lang=js&"
export * from "./SubPantalla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports